import { Component, EventEmitter ,Input, OnInit, Output } from "@angular/core";
import { ConsultaHistoricoMovimientosService } from "../../servicios/consulta-historico-movimientos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { ConsultaHistoricoMovimientos, ConsultaHistoricoMovimientosInput } from "../../entidades/entidades";
@Component({
  selector: "app-consulta-historico-movimientos-grid",
  templateUrl: "./consulta-historico-movimientos-grid.component.html",
  styleUrls: ["./consulta-historico-movimientos-grid.component.css"],
})
export class ConsultaHistoricoMovimientosGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  consultaHistoricoMovimientos: ConsultaHistoricoMovimientos[];
  historicoMovimientos: ConsultaHistoricoMovimientos;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedConsultaHistoricoMovimientos: { [s: string]: ConsultaHistoricoMovimientos } = {};
  buscando: boolean = false;

  @Input("consultaHistoricoMovimientosInput") consultaHistoricoMovimientosInput: ConsultaHistoricoMovimientosInput;
  @Output("consultaHistoricoMovimientos") consultaHistoricoMovimientosOutput: EventEmitter<ConsultaHistoricoMovimientos>;



  constructor(
   private consultaHistoricoMovimientosService: ConsultaHistoricoMovimientosService,
  ) {}

  ngOnInit(): void {
    
    if(this.consultaHistoricoMovimientosInput)
    {
      this.getAllConsultaHistoricoMovimientos();
    }
   

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllConsultaHistoricoMovimientos();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "anio", header: "Año",ordenar: true, styleHeader: "width: 70px;",},
      {field: "bimestre", header: "Bimestre",ordenar: true, styleHeader: "width: 80px;",},
      {field: "lecturaanterior", header: "Lectura Anterior",ordenar: true, styleHeader: "width: 90px;",},
      {field: "lecturaactual", header: "Lectura Actual",ordenar: true, styleHeader: "width: 90px;",},
      {field: "consumo", header: "Consumo",ordenar: true, styleHeader: "width: 130px;",},
      {field: "base", header: "Base",ordenar: true, styleHeader: "width: 130px;",},
      {field: "serviciodrenaje", header: "Drenaje",ordenar: true, styleHeader: "width: 130px;",},
      {field: "manejoconduccion", header: "Manejo",ordenar: true, styleHeader: "width: 130px;",},
      {field: "recargos", header: "Recargos",ordenar: true, styleHeader: "width: 130px;",},
      {field: "actualizacion", header: "Actualizacion",ordenar: true, styleHeader: "width: 130px;",},
      {field: "totalperiodo", header: "Total PerÍodo",ordenar: true, styleHeader: "width: 150px;",},
      {field: "cargoredondeo", header: "Cargo Redondeo",ordenar: true, styleHeader: "width: 90px;",},
      {field: "importeperiodoredondeo", header: "Importe Período Redondeo",ordenar: true, styleHeader: "width: 150px;",},
      {field: "pagado", header: "Pagado",ordenar: true, styleHeader: "width: 90px;",},
      {field: "fechapago", header: "Fecha Pago",ordenar: true, styleHeader: "width: 100px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let consultaHistoricoMovimientosNew = new ConsultaHistoricoMovimientos();
    //consultaHistoricoMovimientosNew.cambio = true;
    consultaHistoricoMovimientosNew.id = 0;
    this.consultaHistoricoMovimientos.unshift(consultaHistoricoMovimientosNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let consultaHistoricoMovimientosEdit = event.data;
    consultaHistoricoMovimientosEdit.cambio = true;
    consultaHistoricoMovimientosEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let consultaHistoricoMovimientosEdit = event.data;
    let index = this.consultaHistoricoMovimientos.findIndex(
      (obj) => obj.id === consultaHistoricoMovimientosEdit.id
    );
    this.consultaHistoricoMovimientos[index] = { ...this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let consultaHistoricoMovimientosEdit = event.data;

      //Valida si hay cambios
      if (
        consultaHistoricoMovimientosEdit.anio === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].anio &&
        consultaHistoricoMovimientosEdit.bimestre === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].bimestre &&
        consultaHistoricoMovimientosEdit.lecturaanterior === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].lecturaanterior &&
        consultaHistoricoMovimientosEdit.lecturaactual === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].lecturaactual &&
        consultaHistoricoMovimientosEdit.consumo === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].consumo &&
        consultaHistoricoMovimientosEdit.base === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].base &&
        consultaHistoricoMovimientosEdit.serviciodrenaje === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].serviciodrenaje &&
        consultaHistoricoMovimientosEdit.manejoconduccion === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].manejoconduccion &&
        consultaHistoricoMovimientosEdit.recargos === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].recargos &&
        consultaHistoricoMovimientosEdit.actualizacion === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].actualizacion &&
        consultaHistoricoMovimientosEdit.totalperiodo === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].totalperiodo &&
        consultaHistoricoMovimientosEdit.cargoredondeo === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].cargoredondeo &&
        consultaHistoricoMovimientosEdit.importeperiodoredondeo === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].importeperiodoredondeo &&
        consultaHistoricoMovimientosEdit.pagado === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].pagado &&
        consultaHistoricoMovimientosEdit.fechapago === this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id].fechapago 
      ) {
        let index = this.consultaHistoricoMovimientos.findIndex((obj) => obj.id === consultaHistoricoMovimientosEdit.id);
        this.consultaHistoricoMovimientos[index] = {...this.clonedConsultaHistoricoMovimientos[consultaHistoricoMovimientosEdit.id]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      consultaHistoricoMovimientosEdit.cambio = true;
      consultaHistoricoMovimientosEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore

  // prettier-ignore
  async addConsultaHistoricoMovimientos(consultaHistoricoMovimientos) {
    try {
      const datoretorno = await this.consultaHistoricoMovimientosService
        .add(consultaHistoricoMovimientos)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addConsultaHistoricoMovimientos");
    }
  }

  // prettier-ignore
  async getAllConsultaHistoricoMovimientos() {
    try {
      this.buscando = true ;
      const datoRetorno = await this.consultaHistoricoMovimientosService.getBusquedas(this.consultaHistoricoMovimientosInput).toPromise();

      this.historicoMovimientos = datoRetorno;
     // for (var i = 0, len = this.consultaHistoricoMovimientos.length; i < len; ++i)
     //   this.clonedConsultaHistoricoMovimientos[this.consultaHistoricoMovimientos[i].id] = {...this.consultaHistoricoMovimientos[i],        };
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.buscando  = false;
      console.log("Paso por getAllConsultaHistoricoMovimientos");
    }
  }

  // prettier-ignore
  async updateConsultaHistoricoMovimientos(consultaHistoricoMovimientos: ConsultaHistoricoMovimientos) {
    try {
      const datoRetorno = await this.consultaHistoricoMovimientosService
        .update(consultaHistoricoMovimientos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateConsultaHistoricoMovimientos");
    }
  }

  // prettier-ignore
  async deleteConsultaHistoricoMovimientos(consultaHistoricoMovimientos: ConsultaHistoricoMovimientos) {
    try {
      const datoRetorno = await this.consultaHistoricoMovimientosService
        .delete(consultaHistoricoMovimientos.id)
        .toPromise();
      this.getAllConsultaHistoricoMovimientos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteConsultaHistoricoMovimientos");
    }
  }
}